import React, { useState } from "react";
import PropTypes from "prop-types";

//
import { Modal } from "react-bootstrap";

//
import ReCAPTCHA from "react-google-recaptcha";

function GoogleRecaptchaModal({ show, setShow, action }) {
  const [captcha, setCaptcha] = useState("");

  const onChange = (e) => {
    if (e) {
      setCaptcha(e)
      action(e)
    }else {
      setCaptcha('')
    }
  };

  return (
    <Modal
      show={show}
      onHide={() => setShow(false)}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      id="captcha-modal"
    >
      <Modal.Header closeButton>
        <h5>Google Recaptcha</h5>
      </Modal.Header>
      <Modal.Body>
        <ReCAPTCHA
          className="google-captcha"
          sitekey="6LfD0p8eAAAAAIYWYNHKDWClCf4eZm-6i1I2mMiy"
          onChange={onChange}
        />
      </Modal.Body>
    </Modal>
  );
}

GoogleRecaptchaModal.propTypes = {
  show: PropTypes.bool.isRequired,
  setShow: PropTypes.func.isRequired,
};

export default GoogleRecaptchaModal;
